export const ProfileView = () => {
  return <div>MyProfile</div>;
};
